// components/forms/DiagnosisPlanForm.js
import React from 'react';

function DiagnosisPlanForm({ diagnosis, setDiagnosis, treatmentPlan, setTreatmentPlan }) {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold mb-4">初步诊断与治疗计划</h2>

            <div className="grid grid-cols-1 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">初步诊断</label>
                    <textarea
                        className="w-full p-2 border rounded"
                        rows="4"
                        placeholder="例如：1. 急性缺血性脑卒中（左侧大脑中动脉区域）&#10;2. 心源性栓塞可能&#10;3. 高血压 3级 极高危&#10;4. 2型糖尿病"
                        value={diagnosis}
                        onChange={(e) => setDiagnosis(e.target.value)}
                    ></textarea>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">诊疗计划</label>
                    <textarea
                        className="w-full p-2 border rounded"
                        rows="6"
                        placeholder="例如：&#10;1. 完善头颅CT、CTA/CTP及相关检查&#10;2. 评估溶栓适应症及禁忌症&#10;3. 脑保护、改善循环、降颅压等对症支持治疗&#10;4. 抗血小板/抗凝治疗&#10;5. 控制血压，血糖&#10;6. 早期卧床休息，预防并发症"
                        value={treatmentPlan}
                        onChange={(e) => setTreatmentPlan(e.target.value)}
                    ></textarea>
                </div>
            </div>
        </div>
    );
}

export default DiagnosisPlanForm;